import { render } from "./Market.vue?vue&type=template&id=84037d84&scoped=true&ts=true"
import script from "./Market.vue?vue&type=script&lang=ts"
export * from "./Market.vue?vue&type=script&lang=ts"

import "./Market.vue?vue&type=style&index=0&id=84037d84&scoped=true&lang=scss"
import "./Market.vue?vue&type=style&index=1&id=84037d84&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84037d84"]])

export default __exports__
import QSpace from 'quasar/src/components/space/QSpace.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QField from 'quasar/src/components/field/QField.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpace,QLinearProgress,QCard,QBtn,QTooltip,QScrollArea,QField,QCircularProgress});
